import React, { useEffect, useState, useCallback } from "react";
import { OrderCard } from '../../components/Cards';
import { getOrders } from "../../configs/ordersConfig";

function AdminOrders() {
    const [orders, setOrders] = useState([]);

    const fetchOrders = useCallback(async () => {
        try {
            const data = await getOrders();
            setOrders(data);
        } catch (error) {
            console.error(error);
        }
    }, []);

    useEffect(() => {
        fetchOrders();
    }, [fetchOrders]);

    return (
        <div className="container-lg pt-2 d-flex flex-column justify-content-center align-items-center mb-2">
            <div className="d-flex flex-column col-md-7 col-11">
                {orders.map((order, index) => (
                    <OrderCard key={index} order={order} onStatusChange={fetchOrders} />
                ))}
            </div>
        </div>
    );
}

export default AdminOrders;
